// extracted by mini-css-extract-plugin
export default {"hideLoadingNoAnimation":"BPEWmV","loaderNoAnimation":"lh2uSJ","hideLoading":"G_6DXQ","loader":"r9sspp"};